/**
 * Replaces all occurrences of a source keyword group ID with the target keyword group ID in an HTML string.
 * Used to prevent duplicated DOM IDs when cloning inherited keyword items.
 */
export const renameKeywordItemsIds = (oldId, newId, itemsHTML) => {
  const expString = new RegExp(oldId, 'g');
  return itemsHTML.replace(expString, newId);
};

/**
 * Regenerates keyword items in the target group by copying item container HTML from source groups.
 * Returns true when content is generated and written, otherwise returns false.
 */
export const regenerateKeywordItemsFromSources = ({
  target,
  sourceIds,
  itemsContainerClassName = 'keywords-items-container',
}) => {
  if (!target || !Array.isArray(sourceIds) || sourceIds.length === 0) {
    return false;
  }

  const $itemsContainer = target.querySelector(`.${itemsContainerClassName}`);
  if (!$itemsContainer) {
    return false;
  }

  let tempContent = '';

  sourceIds.forEach((sourceId) => {
    const $source = document.getElementById(sourceId);
    if (!$source) {
      return;
    }

    const $sourceItemsContainer = $source.querySelector(`.${itemsContainerClassName}`);
    if (!$sourceItemsContainer) {
      return;
    }

    tempContent += renameKeywordItemsIds(sourceId, target.id, $sourceItemsContainer.innerHTML);
  });

  if (!tempContent) {
    return false;
  }

  $itemsContainer.innerHTML = tempContent;
  return true;
};
